import {API_HOST, API_ROOT, http} from "../../util/http";
import {handleTokenErrors} from "./errors";

export const SET_ACTIVE_REGISTER = "register/SET_ACTIVE_REGISTER";

export function setActiveRegister(register) {
    return {
        type: SET_ACTIVE_REGISTER,
        payload: {
            activeRegister: register
        }
    }
}

export function fetchActiveRegister() {
    return (dispatch) => {
        return http.request({url: API_HOST + API_ROOT + 'registers/activeRegister'}, true)
            .then(response => {
                dispatch(setActiveRegister(response.result));
            })
            .catch(error => {
                // Having no open register is a normal state, not a failure. Clear the
                // stored one, otherwise the header keeps offering a register that was
                // just closed.
                if (error.message === 'register_not_found') {
                    dispatch(setActiveRegister(null));
                    return;
                }

                handleTokenErrors(error);
            });
    }
}

const initialState = {
    activeRegister: null,
};

export default function reducer(state = initialState, action) {
    switch (action.type) {
        case SET_ACTIVE_REGISTER: {
            return {
                ...state,
                activeRegister: action.payload.activeRegister
            }
        }
        
        default:
            return state;
    }
}